import { useContextMenu } from "../../../hooks/ContextMenuHook.js";
import { ReactComponent as AddIcon } from "../../../images/icons/glassPlus.svg";
import React, { useRef } from "react";
import GlassContextMenu from "../GlassContextMenu.js";
import logFetchError from "../../../utils/LoggingUtils.js";

export default function AddButton({secureStorageEnabled, setInstallersViewOpen, setCreateInstallerViewOpen})
{
    function uploadFile(event)
    {
        const file = event.target.files[0];
        if(file == null) return;

        let formData = new FormData();
        formData.append("file", file);

        fetch("/admin/api/upload-module", {
                credentials: "include",
                method: "POST",
                body: formData
            }
        )
        .then(async res =>
        {
            if(res.ok)
            {
                alert("Module upload successful!");
                window.location.reload()
            }
            else logFetchError(res);
        });
    }

    const menuId = "add-module-button";

    const hiddenFileInput = useRef(null);

    const { openMenu, closeMenu, isMenuOpen, getMenuPosition } = useContextMenu();

    const handleClick = (e) =>
    {
        e.preventDefault();
        e.stopPropagation();

        if (isMenuOpen(menuId)) {
            closeMenu(menuId);
            return;
        }

        openMenu(menuId, {
            mouseX: e.clientX + 2,
            mouseY: e.clientY - 6,
        });
    };

    const menuItems = [
        {
            label: 'Upload Module',
            action: 'upload',
            onClick: () => hiddenFileInput.current.click()
        },
        {
            label: 'Install Public Module',
            action: 'install-public',
            subMenu: {
                items: [
                    {
                        label: 'GitHub',
                        action: 'public-from-github',
                        onClick: () => console.log('Install from GitHub')
                    },
                    // {
                    //     label: 'OneDrive',
                    //     action: 'public-from-onedrive',
                    //     onClick: () => console.log('Install from OneDrive')
                    // },
                    // {
                    //     label: 'Google Drive',
                    //     action: 'public-from-google-drive',
                    //     onClick: () => console.log('Install from Google Drive')
                    // }
                ]
            }
        }];

        if(secureStorageEnabled)
        {
            menuItems.push({
                label: 'Create Installer',
                action: 'create-installer',
                subMenu: {
                    items: [
                        {
                            label: 'GitHub',
                            action: 'private-from-github',
                            onClick: () => {
                                console.log('Install from Private GitHub');
                                setCreateInstallerViewOpen(true);
                                closeMenu('add-module-button');
                            }
                        },
                        // {
                        //     label: 'OneDrive',
                        //     action: 'private-from-onedrive',
                        //     onClick: () => console.log('Install from OneDrive')
                        // },
                        // {
                        //     label: 'Google Drive',
                        //     action: 'private-from-google-drive',
                        //     onClick: () => console.log('Install from Google Drive')
                        // }
                    ]
                }
            });

            menuItems.push({
                label: 'View Installers',
                action: 'view-installers',
                onClick: () => setInstallersViewOpen(true)
            })
        }

    return (
        <>
            <input
                type="file"
                ref={hiddenFileInput}
                onChange={uploadFile}
                style={{ display: 'none' }}
            />
            <AddIcon id="mod-control-add" onClick={handleClick} title="Add Module"/>
            <GlassContextMenu
                key={menuId}
                menuId={menuId}
                items={menuItems}
                contextMenu={isMenuOpen(menuId) ? getMenuPosition(menuId) : null}
                onClose={() => closeMenu(menuId)}
            />
        </>
    );
}